import Rellax from 'rellax';
export default {
  init() {
    new Rellax('.banner-rellax', {
      center: false,
      wrapper: null,
      round: true,
      vertical: true,
      horizontal: false,
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js